{
  "Seguimiento del pedido": "주문 추적",
  "Enviado": "발송됨",
  "Empaquetado": "포장됨",
  "Recibido": "수령됨",
  "Items del pedido": "주문 상품",
  "En proceso": "처리 중",
  "Devolución solicitada": "반품 요청됨",
  "Devolución en proceso": "반품 진행 중",
  "Devuelto": "반품 완료",
  "Envío": "배송",
  "Devolución": "반품",
  "Ver en tienda": "상점에서 보기",
  "Solicitudes de devolución": "반품 요청",
  "Envíos": "배송",
  "Confirmado": "확인됨",
  "En curso": "진행 중",
  "Seguimiento de envío": "배송 추적",
  "Destino": "목적지",
  "Dirección destino": "목적지 주소",
  "Última actualización": "마지막 업데이트",
  "Devolución pendiente": "반품 대기 중",
  "Recogida solicitada": "픽업 요청됨",
  "Devolución enviada": "반품 발송됨",
  "Entrega estimada": "예상 배송",
  "Valora tu experiencia con nosotros": "저희와의 경험을 평가해 주세요",
  "¡Gracias!": "감사합니다!",
  "Mensaje de alerta": "알림 메시지",
  "Punto de recogida": "픽업 지점",
  "Mostrar historial completo": "전체 이력 보기",
  "Ocultar historial": "이력 숨기기",
  "¿Necesitas hacer una devolución o cambio?": "반품 또는 교환을 원하시나요?",
  "¿Quieres devolver algo más?": "다른 제품도 반품하시겠어요?",
  "Devuelve o cambia tu artículo en pocos pasos.": "몇 가지 간단한 단계로 상품을 반품하거나 교환하세요.",
  "Empieza el proceso en pocos pasos. Te guiaremos durante todo el proceso.": "몇 가지 간단한 단계로 프로세스를 시작하세요. 전체 과정을 안내해 드립니다.",
  "Abrir el portal de devoluciones": "반품 포털 열기",
  "Enviando": "전송 중",
  "¡Página no encontrada!": "페이지를 찾을 수 없습니다!",
  "Lo sentimos, pero no se pudo encontrar la página que estabas buscando": "죄송합니다. 찾으시는 페이지를 찾을 수 없습니다",
  "Puedes volver al ": "다음으로 돌아갈 수 있습니다: ",
  "principio": "처음",
  "o escribirnos a support@reveni.io si no encuentras lo que estabas buscando": "또는 원하는 내용을 찾지 못하셨다면 support@reveni.io로 문의해 주세요"
}
